import Icon from '../../../components/AppIcon';

const StatisticsPanel = ({ totalJobsCompleted, totalReviews, rating, experienceYears }) => {
  // Calculate derived statistics
  const repeatClientRate = totalJobsCompleted > 0 
    ? Math.min(Math.round((totalJobsCompleted * 0.35)), 100) // Simulated repeat rate
    : 0;

  const avgResponseTime = '< 2 hours'; // Simulated response time

  const earningsMilestone = totalJobsCompleted > 0
    ? `₱${(totalJobsCompleted * 2500)?.toLocaleString()}+` // Estimated earnings
    : '₱0';

  const stats = [
    {
      icon: 'CheckCircle',
      label: 'Jobs Completed',
      value: totalJobsCompleted,
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      icon: 'Users',
      label: 'Repeat Client Rate',
      value: `${repeatClientRate}%`,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      icon: 'Clock',
      label: 'Avg Response Time',
      value: avgResponseTime,
      color: 'text-[#FF6A00]',
      bgColor: 'bg-orange-50'
    },
    {
      icon: 'TrendingUp',
      label: 'Total Earnings',
      value: earningsMilestone,
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      icon: 'Star',
      label: 'Average Rating',
      value: rating?.toFixed(1) || '0.0',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      icon: 'MessageSquare',
      label: 'Total Reviews',
      value: totalReviews,
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      icon: 'Award',
      label: 'Experience',
      value: `${experienceYears} years`,
      color: 'text-[#FF6A00]',
      bgColor: 'bg-orange-50'
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-6">
      <h2 className="text-lg font-bold text-foreground mb-4 flex items-center gap-2">
        <Icon name="BarChart3" className="w-5 h-5 text-primary" />
        Statistics
      </h2>

      <div className="space-y-4">
        {stats?.map((stat, index) => (
          <div 
            key={index}
            className="flex items-center gap-4 p-3 rounded-lg bg-background hover:bg-accent/50 transition-colors"
          >
            <div className={`w-10 h-10 rounded-lg ${stat?.bgColor} flex items-center justify-center flex-shrink-0`}>
              <Icon name={stat?.icon} className={`w-5 h-5 ${stat?.color}`} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground mb-0.5">{stat?.label}</p>
              <p className="text-lg font-bold text-foreground truncate">{stat?.value}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Additional Info */}
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-start gap-2 text-xs text-muted-foreground">
          <Icon name="Info" className="w-3 h-3 mt-0.5 flex-shrink-0" />
          <p>Statistics are updated in real-time based on completed jobs and client feedback.</p>
        </div>
      </div>
    </div>
  );
};

export default StatisticsPanel;